import { IconButton, InputAdornment, makeStyles } from '@material-ui/core';
import { SEARCH_CLEAR_ALT_TEXT } from '../../../assets/copy';
import FilledClose from '../../../assets/icons/filledClose.svg';
import Search from '../../../assets/icons/grv-search.svg';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiIconButton-root': {
      background: 'none',
      width: theme.spacing(2.5),
      height: theme.spacing(2.5),
      marginRight: theme.spacing(0.25),
      '& img': {
        width: theme.spacing(2.5),
      },
      '&:focus': {
        borderColor: theme.palette.interactionBlue.main,
        boxShadow: `0 0 0 2px ${theme.palette.interactionBlue.main}`,
        '& .MuiTouchRipple-child': {
          display: 'none',
        },
      },
    },
  },
}));

export const StartAdornment = () => {
  const classes = useStyles();
  return (
    <InputAdornment
      position="start"
      className={clsx(classes.root, classes.startAdornment)}>
      <img src={Search} alt="" />
    </InputAdornment>
  );
};

export const EndAdornment = ({ onClick }) => {
  const classes = useStyles();
  return (
    <InputAdornment
      position="end"
      className={clsx(classes.root, classes.endAdornment)}>
      <IconButton onClick={onClick} aria-label={SEARCH_CLEAR_ALT_TEXT}>
        <img src={FilledClose} alt="" />
      </IconButton>
    </InputAdornment>
  );
};
